import { PromoWebSocket } from '@/network/PromoWebSocket';
import { Utils } from '@/utils/Utils';
import { Adapter } from '@/adapter/Adapter';
import { serverMessage } from '@/mainComponent/store/interfaces/newInterfaces/types';
import { Counter, ICounter } from '@/utils/Counter';

class Network {
  socket: PromoWebSocket;
  adapter: Adapter;

  timeOutReconnect: number = 3000;

  private _pingOutOfConnection: ICounter = new Counter(0, 3);

  initActions() {
    this.connectSocket();
    this.adapter = new Adapter();
    this.addEventListeners();
  }

  addEventListeners(): void {
    promoApp.eventEmitter.on('SET_MESSAGE', (data: serverMessage) => this.adapter.setData(data));
    promoApp.eventEmitter.on('REQUIRE_TOURNAMENT_PLAYERS', ({ id }: { id: number }) => {
      this.socket.queryTournamentPlayers(id);
    });
  }

  connectSocket() {
    this.removeListeners();
    this.socket = new PromoWebSocket(this.getUrlSocket(), this.getUrlSid());
    this.socket.initFunctions();
    this.socket.addEventListener('close', this.onClose.bind(this));
  }

  async onClose(): Promise<any> {
    this.countPingOutOfConnection();

    if (this._pingOutOfConnection.isComplete) {
      return;
    }

    await Utils.delay(this.timeOutReconnect);
    this.connectSocket();
  }

  getUrlSocket(): string {
    const host: string | null = Utils.parseGetParams('host-promo');
    if (!host) throw 'params host-promo in url not found';
    return host.startsWith('ws:') ? host : `wss://${host}`;
  }

  private getUrlSid(): string[] {
    const urlSid: string | null = Utils.parseGetParams('sid');
    return urlSid ? [urlSid] : [];
  }

  removeListeners(): void {
    if (!this.socket) return;
    this.socket.removeEventListener('close', this.onClose.bind(this));
  }

  private countPingOutOfConnection(): void {
    if (navigator.onLine) {
      this._pingOutOfConnection.reset();
      return;
    }

    if (this._pingOutOfConnection.isComplete) return;

    this._pingOutOfConnection.addOne();
  }

  get isOpenSocket(): boolean {
    return this.socket.isOpen;
  }
}

export { Network };
